import { Component, OnDestroy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { ClipboardService } from 'src/app/services/clipboard.service';
import { WindowScrollService } from 'src/app/services/window-scroll.service';
import { ChangelogService } from 'src/app/services/changelog.service';
import { shCheck, shLink, shXmark } from '@beyondtrust/shield-icons';

// Data Sources
import {
	switchStylesDefaultTheme,
	switchStylesDarkTheme,
	switchStylesTypography,
	switchStylesStructure,
} from './switch-styles';

@Component({
	selector: 'app-switch',
	templateUrl: './switch.component.html',
	styleUrls: ['./switch.component.less'],
})
export class SwitchComponent implements OnDestroy {
	public currLive = 'default';
	public currTheme = 'default';
	public currVisible = 'overview';
	public linkIcon = shLink;
	public doThisIcon = shCheck;
	public dontDoThisIcon = shXmark;

	// Imported Style Variables
	public stylesDefault = switchStylesDefaultTheme;
	public stylesDark = switchStylesDarkTheme;
	public stylesTypography = switchStylesTypography;
	public stylesStructure = switchStylesStructure;

	public pageSubNavData = [
		{
			name: 'Overview',
			value: 'overview',
			empty: false,
			children: [],
		},
		{
			name: 'Live example',
			value: 'example',
			empty: false,
			children: [],
		},
		{
			name: 'Developer resources',
			value: 'dev',
			empty: false,
			children: [
				{
					name: 'Getting started',
					value: 'started',
				},
				{
					name: 'Code examples',
					value: 'code',
				},
				{
					name: 'API',
					value: 'api',
				},
			],
		},
		{
			name: 'Styles',
			value: 'styles',
			empty: false,
			children: [],
		},
		{
			name: 'Behaviors',
			value: 'behaviors',
			empty: false,
			children: [
				{
					name: 'Focus',
					value: 'focus',
				},
				{
					name: 'Hover',
					value: 'hover',
				},
				{
					name: 'Disabled',
					value: 'disabled',
				},
				{
					name: 'Toggle',
					value: 'toggle',
				},
				{
					name: 'Notification toast',
					value: 'notification-toast',
				},
			],
		},
		{
			name: 'Usage guidelines',
			value: 'usage',
			empty: false,
			children: [
				{
					name: 'General',
					value: 'general',
				},
				{
					name: 'Content',
					value: 'content',
				},
				{
					name: 'Switches or checkboxes',
					value: 'switches-or-checkboxes',
				},
			],
		},
		{
			name: 'Related',
			value: 'related',
			empty: false,
			children: [],
		},
		{
			name: 'Revision history',
			value: 'history',
			empty: false,
			children: [],
		},
	];

	public switchValue = false;
	public switchDisabled = false;

	constructor(
		private viewportScroller: ViewportScroller,
		private router: Router,
		private clipboardService: ClipboardService,
		public changelogService: ChangelogService,
		scrollService: WindowScrollService
	) {
		scrollService.sectionChange.subscribe((currentSection: string) => {
			this.onVisible(currentSection);
		});
	}

	ngOnDestroy() {
		document.documentElement.setAttribute('data-theme', 'light');
	}
	
	public onAnchorClick(elementId: string): void {
		this.viewportScroller.scrollToAnchor(elementId);
	}

	public changeCurrLive(event): void {
		this.currLive = event.target.value;
	}

	public changeCurrTheme(event): void {
		this.currTheme = event.target.value;
	}

	public copyToClipboard(newValue): void {
		this.clipboardService.createClipboard({
			value: newValue,
			type: 'url',
		});
	}

	public onVisible(section: string): void {
		this.currVisible = section;
	}

	public onSwitchLabelClick(ev, switchElem){
		if(!this.switchDisabled && !switchElem.hostElement.nativeElement.contains(ev.target)){
			this.switchValue = !this.switchValue;
		}
	}

	public switchHTML = `
<kendo-label text="Enable Permission" (click)="onSwitchLabelClick($event, switch)">
	<kendo-switch [disabled]="switchDisabled" #switch name="switch" [(ngModel)]="switchValue"></kendo-switch>
</kendo-label>
	`;

	public switchTS = `
public onSwitchLabelClick(ev, switchElem){
	if(!this.switchDisabled && !switchElem.hostElement.nativeElement.contains(ev.target)){
		this.switchValue = !this.switchValue;
	}
}`;
}
